import { Helmet } from "react-helmet";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ServicesOverview from "@/components/ServicesOverview";
import TrustBanner from "@/components/TrustBanner";
import PostcodeChecker from "@/components/PostcodeChecker";
import DoorTypesMarquee from "@/components/DoorTypesMarquee";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import AreasSection from "@/components/AreasSection";
import EmergencyBanner from "@/components/EmergencyBanner";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { LocalBusinessSchema, FAQSchema, homeFAQs } from "@/components/StructuredData";

const Index = () => {
  return (
    <>
      <Helmet>
        <html lang="en-GB" />
        <title>Garage Door Repairs | Berkshire, Hampshire & Surrey</title>
        <meta 
          name="description" 
          content="24/7 emergency garage door repairs across Berkshire, Hampshire & Surrey. Local engineers fixing broken springs, cables and motors. Call 07836 393815." 
        />
        <meta name="keywords" content="garage door repair UK, 24/7 emergency garage door, garage door servicing Berkshire Hampshire Surrey, smart garage door automation, broken garage door fix, same day garage door repair" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://smartliftgaragedoors.co.uk/" />
        <link rel="alternate" hrefLang="en-GB" href="https://smartliftgaragedoors.co.uk/" />
        <meta property="og:title" content="Garage Door Repairs UK | 24/7 Emergency Service" />
        <meta property="og:description" content="24/7 emergency garage door repairs, servicing & automation. Same-day service where possible. Call 07836 393815." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://smartliftgaragedoors.co.uk/" />
      </Helmet>
      <LocalBusinessSchema />
      <FAQSchema faqs={homeFAQs} />
      <div className="min-h-screen">
        <Header />
        <Hero />
        <ServicesOverview />
        <TrustBanner />
        <PostcodeChecker />
        <DoorTypesMarquee />
        <Services />
        <WhyChooseUs />
        <AreasSection />
        <EmergencyBanner />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Index;
